<template>
  <AuthWrapper>
    <div class="auth-contents">
      <a-form @finish="handleSubmit" :model="formState" layout="vertical">
        <sdHeading as="h3">{{ $t('pages.tfa.title') }}</sdHeading>
        <a-spin :tip="$t('pages.tfa.loading')" v-if="!qrLoaded && qrCode != null"> </a-spin>
        <p v-if="qrLoaded && qrCode != null">
          {{ $t('pages.tfa.create-code') }}
        </p>
        <img :src="qrCode" @load="qrLoaded = true" />
        <p>{{ $t('pages.tfa.remaining-time') }}: {{ timeout }} {{ $t('pages.tfa.second') }}</p>
        <p>
          <router-link to="/auth/login" v-if="timeout < 1">{{ $t('pages.tfa.sign-in-again') }}</router-link>
        </p>
        <div v-if="timeout > 0">
          <a-form-item :label="$t('pages.tfa.enter-code')" name="code">
            <a-input type="text" v-model:value="formState.code" />
          </a-form-item>
          <a-form-item>
            <sdButton class="btn-reset" htmlType="submit" type="primary" size="large" :disabled="isLoading">
              {{ isLoading ? $t('common.loading') : $t('common.submit') }}
            </sdButton>
          </a-form-item>
        </div>
      </a-form>
    </div>
  </AuthWrapper>
</template>
<script>
import { AuthWrapper } from './style';
import axios from 'axios';
import Cookies from 'js-cookie';
import { notification } from 'ant-design-vue';
import { mapGetters } from 'vuex';
import { useRouter } from 'vue-router';

export default {
  name: 'GoogleAuth',
  components: { AuthWrapper },
  data() {
    return {
      timeout: 120,
      qrLoaded: false,
      formState: {
        code: '',
        email: '',
      },
      isLoading: false,
      isChecking: true,
      router: useRouter(),
    };
  },
  methods: {
    handleSubmit() {
      if (this.timeout < 1) {
        this.$message.error(this.$t('pages.tfa.timeout'));
        return false;
      }

      if (this.formState.code == '') {
        this.$message.error(this.$t('pages.tfa.code-required'));
        return false;
      }

      this.isLoading = true;
      axios
        .post(process.env.VUE_APP_API_ENDPOINT + this.$endpoints.auth_google_verify, this.formState)
        .then((response) => {
          if (response.data.status === true) {
            Cookies.set('logedIn', true);
            Cookies.set('token', response.data.data.token);
            Cookies.set(new Buffer.from('apps_is_root', 'binary').toString('base64'), response.data.data.type);
            this.$store.commit('setRoot', response.data.data.type);
            this.$store.commit('loginSuccess', true);
            this.$store.commit('setJwtToken', response.data.data.token);
            this.router.push('/');
          } else {
            notification.error({
              message: response.data.message,
            });
          }
        })
        .catch((e) => {
          notification.error({
            message: 'Error',
          });
        });
      this.isLoading = false;
    },
    countdown() {
      if (this.timeout == 0) {
        return;
      }
      var _this = this;
      setTimeout(function () {
        _this.timeout--;
        _this.countdown();
      }, 1000);
    },
  },
  created() {
    if (this.two_fa_verify == false) {
      this.router.push('/auth/login');
      return false;
    }
    this.formState.email = this.email;
    this.countdown();
  },
  computed: {
    ...mapGetters({
      qrCode: '_qrCode',
      email: '_email',
      two_fa_verify: '_two_fa_verify',
    }),
  },
};
</script>
